import { render, staticRenderFns } from "./SelecaoDePdv.vue?vue&type=template&id=328ad5c4&"
import script from "./SelecaoDePdv.vue?vue&type=script&lang=ts&"
export * from "./SelecaoDePdv.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
